import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireQuizRanking} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';

@Injectable()
export class QuizRankingService implements CrudService<UmpireQuizRanking> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireQuizRanking[]>> {
    return this.http
      .get('/quiz_rankings', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizRanking>> {
    return this.http
      .get(`/quiz_rankings/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/quiz_rankings/${id}`);
  }

  create(
    body: Partial<UmpireQuizRanking>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizRanking>> {
    return this.http.post<JsonApiResponse<UmpireQuizRanking>>(
      '/quiz_rankings',
      serialize({stuff: body}),
      {
        params: objectToHttpParams(params),
      },
    );
  }

  update(
    body: Partial<UmpireQuizRanking>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireQuizRanking>> {
    return this.http
      .patch<JsonApiResponse<UmpireQuizRanking>>(
        `/quiz_rankings/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
